const KEY_ALLOWED_NUMBER = [
	'0',
	'1',
	'2',
	'3',
	'4',
	'5',
	'6',
	'7',
	'8',
	'9',
	'.',
];
const KEY_ALLOWED_CONTROL = [
	'Backspace',
	'Delete',
	'ArrowDown',
	'ArrowLeft',
	'ArrowRight',
	'ArrowUp',
	'End',
	'Tab',
];

export function invalidKeyCodeForNumber(ev: any) {
	return (
		!ev.metaKey && //allow Cmd/Ctrl-<key>
		!ev.ctrlKey &&
		![...KEY_ALLOWED_NUMBER, ...KEY_ALLOWED_CONTROL].includes(ev.key)
	);
}
